import { configureStore } from '@reduxjs/toolkit';
import providerItemsReducer from './slices/providerItemsSlice';


export const store = configureStore({
  reducer: {
    providerItems: providerItemsReducer
  },
});